import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OrderLine } from '../../../../graphql/generated/generated-types';
import { FormatPricePipe } from '../../../pipes/format-price.pipe';
import { FormatPriceUnitPipe } from '../../../pipes/format-price-unit.pipe';


@Component({
  selector: 'app-delivery-items-table-price-block',
  standalone: true,
  imports: [CommonModule, FormatPricePipe, FormatPriceUnitPipe, ProgressSpinnerModule],
  templateUrl: './delivery-items-table-price-block.component.html',
  styleUrl: './delivery-items-table-price-block.component.scss'
})
export class DeliveryItemsTablePriceBlockComponent {
  @Input() orderLine: OrderLine;
  @Input() product: any;
}
